import { IconButton, styled } from '@nextiva/next-ui-components';

export const StyledIconButton = styled(IconButton)`
  height: 32px;
  width: 32px;
  color: ${({ theme }) => theme.palette.blueGrey.A400};
  border-radius: 0.25rem;

  &.active {
    background-color: ${({ theme }) => theme.palette.grey.A50};
  }

  &:not(:first-of-type) {
    margin-left: 1rem;
  }
`;